import axios from '@/utils/request'

const agentLoginUrl = '/data/user/agentLogin'
const agentLogin = async (body) => {
  const { data } = await axios.post(agentLoginUrl, body)
  return data.data
}

const agentLoginByCodeUrl = '/data/user/agentLoginByCode'
const agentLoginByCode = async (body) => {
  const { data } = await axios.post(agentLoginByCodeUrl, body)
  return data.data
}

const inviteInfoUrl = '/user/invite/info'
const inviteInfo = async (body) => {
  const { data } = await axios.post(inviteInfoUrl, body)
  return data.data
}

const userInfoUrl = '/data/userInfo'
const userInfo = async (body) => {
  const { data } = await axios.post(userInfoUrl, body)
  return data.data
}

const areaListUrl = '/user/query/country-code'
const areaList = async (body = {}) => {
  const { data } = await axios.post(areaListUrl, body, { auth: false })
  return data.data
}

const getQrcodeUrl = '/user/qrcode/getCode'
const getQrcode = async (body = {}) => {
  const { data } = await axios.post(getQrcodeUrl, body, { auth: false })
  return data.data
}

const getQrcodeStatusUrl = '/user/qrcode/codeStatus'
const getQrcodeStatus = async (body = {}) => {
  const { data } = await axios.post(getQrcodeStatusUrl, body, { auth: false })
  return data.data
}

const getQrcodeExpiredCodeUrl = '/user/qrcode/expiredCode'
const getQrcodeExpiredCode = async (body = {}) => {
  const { data } = await axios.post(getQrcodeExpiredCodeUrl, body, { auth: false })
  return data.data
}

const needLoginUrl = []

export default {
  needLoginUrl,
  agentLogin,
  agentLoginByCode,
  inviteInfo,
  userInfo,
  areaList,
  getQrcode,
  getQrcodeStatus,
  getQrcodeExpiredCode,
}
